import React, { Component } from 'react';
import logo from "../../images/GM-Cabs-card-logo.jpg";
import '../../stylesheet/guestnavbar.css'
import TextField from 'material-ui/TextField'
import ios from '../../images/ios.png'
import android from '../../images/android.png'
import RaisedButton from 'material-ui/RaisedButton';
import {
    Link, NavLink
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import services from '../../services/allservices.jsx'




const styles = {
    activeStyle: {
        backgroundColor: "#fff",
        boxShadow: "0 0px 0px 0px rgba(42, 81, 148, 0.2), 0 16px 16px -11px rgba(42, 81, 148, 0.6)",
        border: "1px solid #f5f5f5",
        borderBottom: "2px solid #333",
    },
    customWidth: {
        width: "100%",
        fontSize: "14px",
        color: "#333"
    },
    floatingLabelStyle: {
        color: "#fff",
        fontSize: "19px",
        fontWeight: "600"
    },
    modalfloatingLabelStyle: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: "600"
    },
    floatingLabelFocusStyle: {
        color: "#333"
    },
    modalfloatingLabelFocusStyle: {
        color: "#333"
    },
    underlineFocusStyle: {
        color: "#fff"
    },
    radioButton: {
        fill: "#333",
    },
    underlineFocusStyle: {
        color: "#333"
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    SelectDisplayProps: {
        maxHeight: "383px",
        top: "260px"
    },
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400,
    },
    inkBarStyle: {
        background: "#fff"
    },
    tab: {
        background: "#007bff"
    },
    inputStyle: {
        color: "#333"
    },
    modalinputStyle: {
        color: "#333"
    },
    listStyle: {
        color: "#fff"
    },
    selectedMenuItemStyle: {
        color: "#fff"
    },
    buttonStyle: {
        minWidth: "40px",
        height: "0px"
    }
};

class GusetNavbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            disabled: false
        }
    }
    handleHover = () => {
        document.getElementById("appDownload").style.display = "block"
    }
    handleOut = () => {
        document.getElementById("appDownload").style.display = "none"
    }
    onFieldChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }

    handleSendLink = () => {
        let state = {
            emailId: this.state.email
        }
        fetch(services.send_api_link, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(state)
        })
            .then(
                function (response) {
                    if (response.status === 200 || response.status === 201 || response.status === 204) {
                        toast.success(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                    else {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            draggablePercent: 60,
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        });
                    }
                }
            )
    }
    render() {
        return (
            <nav className="navbar navbar-expand-sm bg-trans navbar-dark fixed-top" >
                <Link to="/" className="navbar-brand" href="#"><img src={logo} alt='' style={{ height: 70, width: 170 }} /></Link>
                <ul className="nav justify-content-end" style={{ width: "100%" }}>


                    <li className="nav-item nav-tab-padding " style={{ width: "13%" }}>
                        <NavLink exact activeStyle={styles.activeStyle} to="/" className="nav-link text-dark">
                            Home
                        </NavLink>
                    </li>
                    <li className="nav-item nav-tab-padding " style={{ width: "13%" }}  onMouseOver={this.handleHover.bind(this)} onMouseOut={this.handleOut.bind(this)}>
                        <NavLink exact to="" className="nav-link text-dark">
                        Download App
                        </NavLink>
                    </li>
                    {/* <li className="nav-item nav-tab-padding " style={{ width: "13%" }}>
                        <NavLink exact activeStyle={styles.activeStyle} to="/contact-us" className="nav-link text-dark">
                            Contact us
                        </NavLink>
                    </li> */}
                    <li className="nav-item nav-tab-padding " style={{ width: "13%" }}>
                        <NavLink exact activeStyle={styles.activeStyle} to="/faqs" className="nav-link text-dark">
                            FAQs
                        </NavLink>
                    </li>
                </ul>

                <div className="offset-sm-8 col-sm-4" id="appDownload" onMouseOver={this.handleHover.bind(this)} onMouseOut={this.handleOut.bind(this)} style={{ background: "rgba(114, 161, 175, 0.92)", paddingLeft: "30px", marginTop: "85px", position: "absolute", borderRadius: "5px", display: "none" }}>

                    <div className="row">
                        <div className="offset-sm-5 triangleup" style={{ width: "0", height: "0", borderLeft: "10px solid transparent", borderRight: "10px solid transparent", borderBottom: "15px solid rgba(114, 161, 175, 0.92)", marginTop: "-15px" }}> </div>
                        <div className="col-sm-12 " style={{ marginLeft: "20px" }}>
                            <div className="row">
                                <div className="col-sm-7" style={{ paddingLeft: "5px" }} >
                                    <TextField
                                        hintText=""
                                        floatingLabelText="Email"
                                        name="email"
                                        style={styles.customWidth}
                                        floatingLabelStyle={styles.modalfloatingLabelStyle}
                                        floatingLabelFocusStyle={styles.modalfloatingLabelFocusStyle}
                                        underlineFocusStyle={styles.focusStyle}
                                        inputStyle={styles.modalinputStyle}
                                        // labelStyle={{color:"#333"}}
                                        onChange={this.onFieldChange.bind(this)}
                                    />
                                </div>
                                <div className="col-sm-4" style={{ marginTop: "40px", padding: "0px" }}>
                                    <RaisedButton
                                        label="Send App Link"
                                        // disabled={this.state.disabled}
                                        // className="card-submit"
                                        backgroundColor="rgb(14, 14, 14)"
                                        labelColor="#fff"
                                        style={styles.buttonStyle}
                                        buttonStyle={{ height: "25px", lineHeight: "0px" }}
                                        labelStyle={{ paddingLeft: "12px", paddingRight: "12px", textTransform: "capitalize" }}
                                        onClick={this.handleSendLink.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="offset-2 col-sm-10" style={{ padding: "5px 0px 3px 0px", textAlign: "center", marginBottom: "10px", boxShadow: "0px 0px 4px #72a1af" }}>
                            <div className="row">
                                <div className="col-sm-4">
                                    <a href="https://play.google.com/store/apps/details?id=com.oxygen.gmcabs">
                                        <img style={{ fontSize: "12px", height: "35px", marginLeft: "2px", cursor: "pointer" }} src={android} />
                                    </a>
                                </div>
                                <div className="col-sm-4">
                                    <a href="https://itunes.apple.com/au/app/gmcabs-prepaid-visa-card/id1423522704?mt=8">
                                        <img style={{ fontSize: "12px", height: "35px", marginLeft: "2px", cursor: "pointer" }} src={ios} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </nav >
        );
    }
}

export default GusetNavbar;


// WEBPACK FOOTER //
// ./src/components/navigation/guestnavbar.jsx